export const dataLcs = [
  {
    label: 'Painel Geral',
    value: 'indicadores_painel_geral',
  },
  {
    label: 'Linha de Cuidado Acidente Vascular Cerebral',
    value: 'acidente_vascular_cerebral',
  },
  {
    label: 'Linha de Cuidado Câncer de Mama',
    value: 'cancer_de_mama',
  },
  {
    label: 'Linha de Cuidado Câncer de Próstata',
    value: 'cancer_de_prostata',
  },
  {
    label: 'Linha de Cuidado Quadril',
    value: 'artropatia_de_quadril',
  },
  {
    label: 'Linha de Cuidado Sepse',
    value: 'sepse_e_choque_septico',
  },
  {
    label: 'Linha de Cuidado Síndrome Coronariana Aguda',
    value: 'sindrome_coronariana_aguda',
  },
];
